const STEPS = [
  {
    n: 1,
    title: 'Market Entry',
    body: 'We analyze your product fit, identify target markets, and plan the optimal entry strategy.',
    bullet: 'Category benchmarking and competitive landscape analysis',
  },
  {
    n: 2,
    title: 'Distribution',
    body: 'Your products go live on our app and in partner retail stores across ANZ territories.',
    bullet: 'Dedicated account manager for onboarding and logistics',
  },
  {
    n: 3,
    title: 'Marketing & Visibility',
    body: 'We promote your brand through our consumer channels, driving awareness and demand.',
    bullet: 'Influencer and community marketing within Indian diaspora',
  },
  {
    n: 4,
    title: 'Data Feedback Loop',
    body: 'Get insights on sales, pricing, pack sizes, and regional performance to optimize.',
    bullet: 'Monthly brand performance dashboard shared with partners',
  },
];

export const HowWeLaunch = () => (
  <section id="how-we-launch" className="py-20 md:py-32 bg-gray-50">
    <div className="container mx-auto px-6">
      <div className="text-center mb-16">
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">How We Launch Brands</h2>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto">
          A systematic approach to market entry, distribution, and growth in ANZ.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {STEPS.map((s) => (
          <div key={s.n} className="relative">
            <div className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow">
              <div className="h-14 w-14 bg-[#004aad] text-white rounded-lg flex items-center justify-center mb-4 text-2xl font-bold">
                {s.n}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{s.title}</h3>
              <p className="text-gray-600 mb-3">{s.body}</p>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• {s.bullet}</li>
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
